export const depositDocumentPath = (eventId: number) => `/dashboards/jobTracker/deposit/${eventId}`;

const cents = (amount: number) => Number.isFinite(amount) ? Math.round((amount + Number.EPSILON) * 100) : 0;

export const recordedPaymentStatus = (invoiced: number, paid: number) => {
  const invoiceCents = cents(invoiced);
  const paidCents = cents(paid);
  return paidCents > invoiceCents ? 'Overpaid'
    : paidCents > 0 && paidCents === invoiceCents ? 'Paid In Full'
    : paidCents > 0 ? 'Partially Paid' : 'Awaiting Payment';
};

export function depositSummary(event: any) {
  const invoiced = Number(event?.depositPaid || 0);
  const paid = Number(event?.totalClientPaid || 0);
  const delivery = event?.depositEmailDelivery;
  const deliveryLabel = delivery?.status === 'ACCEPTED' ? `Provider Accepted ${new Date(delivery.acceptedAt).toLocaleString()}`
    : delivery?.status === 'QUEUED' ? 'Email Queued - Awaiting Provider Acceptance'
    : delivery?.status === 'FAILED' ? 'Email Failed - Retry Available'
    : delivery ? 'Email Delivery Unconfirmed - Review Before Resending'
    : 'Sent date unavailable for this deposit record.';
  return {
    visible: event?.isDepositSent === true || Boolean(delivery),
    deliveryLabel,
    lastAcceptedLabel: delivery?.status !== 'ACCEPTED' && delivery?.lastAccepted?.acceptedAt ? `Previous Deposit Provider Accepted ${new Date(delivery.lastAccepted.acceptedAt).toLocaleString()}` : undefined,
    invoiced, paid, remaining: (cents(invoiced) - cents(paid)) / 100,
    status: recordedPaymentStatus(invoiced, paid)
  };
}
